export default __webpack_public_path__ + "static/media/screen5.b3af6053.jpg";